import Nav from "../components/landing/Nav";
import Hero from "../components/landing/Hero";
import Pain from "../components/landing/Pain";
import Signals from "../components/landing/Signals";
import Frozen from "../components/landing/Frozen";
import Benefits from "../components/landing/Benefits";
import FeatureGrid from "../components/landing/FeatureGrid";
import ProPricing from "../components/landing/ProPricing";
import AdhdSafeUsage from "../components/landing/AdhdSafeUsage";
import Privacy from "../components/landing/Privacy";
import MindFrame from "../components/landing/MindFrame";
import Scenarios from "../components/landing/Scenarios";
import Walkthrough from "../components/landing/Walkthrough";
import HowItWorks from "../components/landing/HowItWorks";
import FinalCta from "../components/landing/FinalCta";
import Footer from "../components/landing/Footer";
import { useEffect } from "react";

export default function Landing() {
  // Lightweight in-view fade utility (no framer-motion needed)
  useEffect(() => {
    const els = document.querySelectorAll(".fade-up");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <main
      data-testid="landing-page"
      className="min-h-screen bg-[#F8FAFC] text-[#0F172A] font-body antialiased overflow-x-hidden"
    >
      <Nav />
      <Hero />
      <Pain />
      <Signals />
      <Frozen />
      <Benefits />
      <FeatureGrid />
      <ProPricing />
      <AdhdSafeUsage />
      <Walkthrough />
      <Scenarios />
      <Privacy />
      <MindFrame />
      <HowItWorks />
      <FinalCta />
      <Footer />
    </main>
  );
}
